import { IActionJavaData, IActionWebConfig, IAction, createActionUtils } from '@droid/project-v2-interface'
import { ulid } from "ulid"
import { UI } from "./UI"
import { appActionNamespace } from "../app-namespace"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, '[IToAppMainPage]')
fileLog.pause = true
fileLog.childrenPaused = true

const type = `${appActionNamespace}toAppMainPage`
fileLog.log('[IToAppMainPage] type:', type)

export interface IActionToAppMainPageJavaData extends IActionJavaData {
    pn: string
    an: string
}

export interface IActionToAppMainPageWebConfig extends IActionWebConfig {
    // ToAppMainPage Action 特有的 Web 配置
}

export interface IActionToAppMainPage extends IAction<IActionToAppMainPageJavaData, IActionToAppMainPageWebConfig> {
    javaData: IActionToAppMainPageJavaData
}

function createDefaultData(): IActionToAppMainPage {
    fileLog.log('[createDefaultData] 开始创建默认数据')
    const ulidValue = ulid()
    const data = {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        type,
        javaData: {
            pn: '',
            an: ''
        },
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
    fileLog.log('[createDefaultData] data:', JSON.stringify(data))
    return data
}

function init() {
    fileLog.log('[init] toAppMainPage 初始化')
}

export const actionToAppMainPageUtils = createActionUtils(type, init, createDefaultData, UI)
